// Estado do painel de ajuda do Nexo (Zustand, só UI/sessão). Instância ÚNICA por app: o mascote e o botão
// "Ajuda desta tela" acionam o MESMO painel por este store, sem duplicar o mecanismo. Preferências de
// minimizar/movimento reduzido ficam em localStorage (persistem entre sessões no mesmo dispositivo).
import { create } from "zustand";

const MINIMIZED_KEY = "nexoMinimized";
const REDUCE_MOTION_KEY = "nexoReduceMotion";

function readFlag(key: string): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(key) === "1";
}

function writeFlag(key: string, value: boolean) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(key, value ? "1" : "0");
}

export type HelpView = "menu" | "screen" | "roles" | "article";

type HelpPanelState = {
  open: boolean;
  minimized: boolean;
  reduceMotion: boolean;
  view: HelpView;
  /** Slug/id do artigo a abrir quando view === "article". */
  articleRef: string | null;
  openMenu: () => void;
  openScreenHelp: () => void;
  openArticle: (slugOrId: string) => void;
  close: () => void;
  setMinimized: (minimized: boolean) => void;
  setReduceMotion: (reduceMotion: boolean) => void;
  setView: (view: HelpView) => void;
};

export const useHelpPanel = create<HelpPanelState>((set) => ({
  open: false,
  minimized: readFlag(MINIMIZED_KEY),
  reduceMotion: readFlag(REDUCE_MOTION_KEY),
  view: "menu",
  articleRef: null,
  openMenu: () => set({ open: true, minimized: false, view: "menu", articleRef: null }),
  openScreenHelp: () => set({ open: true, minimized: false, view: "screen", articleRef: null }),
  openArticle: (slugOrId) => set({ open: true, minimized: false, view: "article", articleRef: slugOrId }),
  close: () => set({ open: false }),
  setMinimized: (minimized) => {
    writeFlag(MINIMIZED_KEY, minimized);
    set({ minimized, open: minimized ? false : true });
  },
  setReduceMotion: (reduceMotion) => {
    writeFlag(REDUCE_MOTION_KEY, reduceMotion);
    set({ reduceMotion });
  },
  setView: (view) => set({ view }),
}));
